export const LoginAPI="/oauth/login"
export const getUserSubscriptionAPI="external/user/subscriptions";
